import { useLocale, OutputChannels } from 'src/modules/locale';

/**
 * Adds Walter Knoll or WalterK. to title depending on the output channel
 */
export const useMetaTitle = (title: string) => {
  const { outputChannel } = useLocale();

  if (!outputChannel) return title;
  if (outputChannel === OutputChannels.US) return title + ' | Walter K.';
  return title + ' | Walter Knoll';
};
